import React, { useContext } from "react";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { CollapsibleBox } from ".";
import { PreviewContext } from "../helpers";

const LimitsApplyAccordion: React.FunctionComponent<{
  descriptors: {
    authorization_required: boolean;
    plan_limits: boolean;
    referral_required: boolean;
  };
}> = ({
  descriptors: { authorization_required, plan_limits, referral_required },
}) => {
  const previewMode = useContext(PreviewContext);
  if (!authorization_required && !plan_limits && !referral_required)
    return null;

  return (
    <div data-testid="limits-accordion">
      <CollapsibleBox
        labelId={"plan_terms.limits_apply"}
        titleClassname="ds-u-margin--0"
        tealiumProps={{
          event_action: "Plan Details",
          event_label: "Toggle - limits apply",
        }}
        open={previewMode}
      >
        {authorization_required && (
          <div className="ds-u-margin-y--2">
            <FormattedHTMLMessage id="plan_terms.limits.advanced_plan_approval_required" />
          </div>
        )}

        {referral_required && (
          <div className="ds-u-margin-y--2">
            <FormattedHTMLMessage id="plan_terms.limits.physician_referral_required" />
          </div>
        )}

        {plan_limits && (
          <div className="ds-u-margin-y--2">
            <FormattedHTMLMessage id="plan_terms.limits.plan_limits" />
          </div>
        )}
      </CollapsibleBox>
    </div>
  );
};

export default LimitsApplyAccordion;
